import img from "./pick_download.png";

import Header from "../../layout/Header/Header";
import Footer from "../../layout/Footer/Footer";
import Breadcrumbs from "../../common/Breadcrumbs/Breadcrumbs";
import UButton from "../../common/Button/UButton/UButton";
import { getKnowledgeCategoriesThunk } from "../../../redux/actions/User/profile/KnowledgeBase/thunk/getKnowledgeCategories.thunk.action";
import { getKnowledgeFilesThunk } from "../../../redux/actions/User/profile/KnowledgeBase/thunk/getKnowledgeFiles.thunk.action";
import {
    downloadKnowledgeFileThunkAction,
} from "../../../redux/actions/User/profile/KnowledgeBase/thunk/downloadKnowledgeFile.thunk.action";

import  {  FileIcon ,  defaultStyles  }  from  "react-file-icon" ;
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./KnowledgeBase.scss";
import moment from "moment";

const KnowledgeBase = () => {
    const dispatch = useDispatch();
    const knowledgeBase = useSelector((state) => state.personalData?.knowledgeBase);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const categories = knowledgeBase?.categories || [];
    const files = knowledgeBase?.files || {};
    const loading = knowledgeBase?.loading || false;
    const error = knowledgeBase?.error || null;

    useEffect(() => {
        dispatch(getKnowledgeCategoriesThunk());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        if (!files[category.type]) {
            dispatch(getKnowledgeFilesThunk(category.type));
        }
    };

    const handleBack = () => {
        setSelectedCategory(null);
    };
    const getExtension = (contentType) => contentType.split("/").pop();
    const formatSize = (bytes) => {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };
    if (selectedCategory) {
        const categoryFiles = files[selectedCategory.type] || [];

        return (
            <>
                <Header />
                <Breadcrumbs />
                <section className={"knowledge-base"}>
                    <h1 className={"sub-header"}>{selectedCategory.title}</h1>
                    <div className={"knowledge-base__files"}>
                        {loading && <div className={"knowledge-base__loading"}>Загрузка...</div>}
                        {!loading && categoryFiles.map((file, index) => (
                            <div className={"knowledge-base__files__item"} key={index}>
                                {/*<img src={img} alt="#" />*/}
                                <div className={"knowledge-base__files__item__img"}>
                                    {/* eslint-disable-next-line max-len */}
                                    < FileIcon  extension = {getExtension(file.contentType)} { ... defaultStyles[getExtension(file.contentType)] }  />
                                </div>
                                <div className={"knowledge-base__files__item__container"}>
                                    <a
                                        className={"knowledge-base__file"}
                                        onClick={()=>dispatch(downloadKnowledgeFileThunkAction(file.url))}
                                        target={"_blank"}
                                        rel={"noreferrer"}
                                    >
                                        {file.title}
                                    </a>
                                    <div>
                                        <span>
                                            {
                                                getExtension(file.contentType).toUpperCase() + " - "
                                            }
                                        </span>
                                        <span>
                                            {
                                                formatSize(file.size) + " - "
                                            }
                                        </span>
                                        <span>

                                                обновлен: {moment(file.lastModified).format("DD.MM.YYYY")}

                                        </span>
                                    </div>
                                </div>
                            </div>

                        ))}
                    </div>
                    <UButton className={"ui-back-button"} onClick={handleBack}>
                        назад
                    </UButton>
                </section>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Header />
            <Breadcrumbs />
            <section className={"knowledge-base"}>
                <h1 className={"sub-header"}>База знаний</h1>
                {error && <div className={"knowledge-base__error"}>{error}</div>}
                <div className={"hr-services"}>
                    {categories.map((category, index) => (
                        <div
                            key={index}
                            className={"hr-services__item"}
                            onClick={() => handleCategoryClick(category)}
                        >
                            <div className={"hr-services__block-head"}>
                                <div>{category.title}</div>
                            </div>
                            <div className={"hr-services__description"}>
                                {category.description}
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <Footer />
        </>
    );
};

export default KnowledgeBase;
